export default __webpack_public_path__ + "static/media/element_32.3b2261f5.jpg";